import React, { createContext, useContext } from 'react';

export const AppConfigContext = createContext();

export const useAppConfig = () => useContext(AppConfigContext);

export const AppConfigProvider = ({ config, children }) => (
    <AppConfigContext.Provider value={config}>
        {children}
    </AppConfigContext.Provider>
);
